import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class RecurringPaymentsProductManagementMixin extends Vue {
	protected getI18nOfThis(key: string, optionValues?: { [key: string] : string }): string {
		return this.$t(`RECURRINGPAYMENTS_PRODUCT_${key}`, optionValues) as string;
	}
}